if(document.querySelector(".spotpricesearch-component")) {
    import(
        /* webpackChunkName: "spotpricesearch-component" */
        /* webpackMode: "lazy" */
        './spotpricesearch-component'
    );
}

if(document.querySelector(".spotprice-component")) {
    import(
        /* webpackChunkName: "spotprice-component" */
        /* webpackMode: "lazy" */
        './spotprice-component'
    );
}

if(document.querySelector(".companydongel-component")) {
    import(
        /* webpackChunkName: "companydongel-component" */
        /* webpackMode: "lazy" */
        './companydongel-component'
    );
}

if(document.querySelector(".companycontact-component")) {
    import(
        /* webpackChunkName: "companycontact-component" */
        /* webpackMode: "lazy" */
        './companycontact-component'
    );
}

if(document.querySelector(".webview-privacy")) {
    import(
        /* webpackChunkName: "webview-privacy" */
        /* webpackMode: "lazy" */
        './webview-privacy'
    );
}

if(document.querySelector(".contact-component")) {
    import(
        /* webpackChunkName: "contact-component" */
        /* webpackMode: "lazy" */
        './contact-component'
    );
}
if (document.querySelector(".ordercontrol-component")) {
    import(
        /* webpackChunkName: "ordercontrol-component" */
        /* webpackMode: "lazy" */
        './ordercontrol-component'
    );
}

if (document.querySelector(".ordercharger-component")) {
    import(
        /* webpackChunkName: "ordercharger-component" */
        /* webpackMode: "lazy" */
        './ordercharger-component'
    );
}

if (document.querySelector(".elbillader-component")) {
    import(
        /* webpackChunkName: "elbillader-component" */
        /* webpackMode: "lazy" */
        './elbillader-component'
    );
}

if (document.querySelector(".dongel-component")) {
    import(
        /* webpackChunkName: "dongel-component" */
        /* webpackMode: "lazy" */
        './dongel-component'
    );
}

if (document.querySelector(".newsletter-component")) {
    import(
        /* webpackChunkName: "newsletter-component" */
        /* webpackMode: "lazy" */
        './newsletter-component'
    );
}

if (document.querySelector(".companyorder-component")) {
    import(
        /* webpackChunkName: "companyorder-component" */
        /* webpackMode: "lazy" */
        './companyorder-component'
    );
}

if (document.querySelector(".sponsor-component")) {
    import(
        /* webpackChunkName: "sponsor-component" */
        /* webpackMode: "lazy" */
        './sponsor-component'
    );
}
